module.exports = __webpack_public_path__ + "static/agiletour-be6c2344fca4936a915dc99c872bbf2e.png";